export class UwchlwythoFfeil {
    teitl: string;
    accept: string;
    url: string;

    constructor(teitl: string, accept: string, url: string) {
        this.teitl = teitl;
        this.accept = accept;
        this.url = url;
    }
}
